import type { Options } from '@ckprivate/ckf-ui';

type SortOption = NonNullable<Options['sort']>;

function getValue(row: any, accessor: string): any {
  return accessor
    .split('.')
    .reduce((value: any, key) => (value == null ? value : value[key]), row);
}

function compare(a: any, b: any): number {
  if (a == null) return b == null ? 0 : 1;
  if (b == null) return -1;

  if (typeof a === 'string' && typeof b === 'string') {
    return a.localeCompare(b);
  }

  if (a === b) return 0;
  return a < b ? -1 : 1;
}

/**
 * Tri des lignes en amont de la Table ckf-ui, dont le tri interne n'expose
 * aucun moyen de connaître la colonne choisie par l'utilisateur.
 * Les valeurs nulles sont toujours reléguées en fin de liste.
 */
export default function sortRows<T>(rows: T[], sort: SortOption): T[] {
  const accessor = sort.columnAccessor;
  if (!accessor) {
    return rows;
  }

  const sorted = [...rows].sort((a, b) =>
    compare(getValue(a, accessor), getValue(b, accessor))
  );

  return sort.direction === 'desc' ? sorted.reverse() : sorted;
}
